import { createSlice } from '@reduxjs/toolkit';
import {
	getModerationList,
	getUsersList,
	getAdminList,
	createAdministrator
} from './userActions';


const initialState = {
	loading: false,
	users: [],
	admins: [],
	modetationList: [],
	error: false,
};

const userSlice = createSlice({
	name: 'user',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
		.addCase(getModerationList.pending, (state) => {
			state.loading = true;
		})
		.addCase(getModerationList.fulfilled, (state, action) => {
			state.loading = false;
			state.modetationList = action.payload.data;
		})
		.addCase(getModerationList.rejected, (state, action) => {
			state.loading = false;
			state.error = true;
		})
		.addCase(getUsersList.pending, (state) => {
			state.loading = true;
		})
		.addCase(getUsersList.fulfilled, (state, action) => {
			state.loading = false;
			state.users = action.payload;
		})
		.addCase(getUsersList.rejected, (state) => {
			state.loading = false;
			state.error = true;
		})
		.addCase(getAdminList.pending, (state) => {
			state.loading = true;
		})
		.addCase(getAdminList.fulfilled, (state, action) => {
			state.loading = false;
			state.admins = action.payload;
		})
		.addCase(getAdminList.rejected, (state) => {
			state.loading = false;
			state.error = true;
		})
		.addCase(createAdministrator.pending, (state) => {
			state.loading = true;
		})
		.addCase(createAdministrator.fulfilled, (state) => {
			state.loading = false;
		})
		.addCase(createAdministrator.rejected, (state) => {
			state.loading = false;
			state.error = true;
		});
	},
});

export default userSlice.reducer;
